/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
/**
 * @module Math
 * Functions, types, and classes for mathematical computations.
 */
export * as Complex from "./Index.Complex.ts";
export * as Vector from "./Vector.ts";
export * from "./Math.ts";
export * from "./Math.Types.ts";
